import React from 'react';
import ReactDOM from 'react-dom';
import MyContent from './MyContent'; // Corrected import statement
import { MyPlanet } from './MyPlanet'; // Importez le composant MyPlanet depuis le fichier où il est défini

// Styles to center the content in the middle of the page
const centerStyle = {
  display: 'flex',
  justifyContent: 'center', // Center horizontally
  alignItems: 'center', // Center vertically
  height: '75vh', // Use 100% of the viewport height to center vertically
  width: '50vw' // Use 100% of the viewport width to center horizontally
};

// Simply render the MyContent component in the middle of the page
ReactDOM.render(

  <div style={centerStyle}>
        <MyPlanet /> 
        <MyContent />
    </div>, document.getElementById('root') // Make sure your index.html has a div with the id "root"
);
